<template>
  <v-col :cols="12" :sm="12" :md="12">
    <v-alert type="error" v-show="erro">
      {{ mensagemErro }}
    </v-alert>
    <DataTable
      :classTitle="'Produtos'"
      :tableTitle="'Produtos em Estoque'"
      :tableHeader="headers"
      :tableData="itens"
      :modalFormComposition="formComposition"
      :onUpdate="atualizar"
      :onInsert="inserir"
      :onDelete="deletar"
      :onUpdateDataTable="listarMateriais"
      :onUpdateoptions="updataOpçoes"
      :isLoadingRequestDisable="isLoadingRequestDisable"
    ></DataTable>
  </v-col>
</template>

<script>
import axios from "../plugins/axios";
import DataTable from "../components/DatatableMaterial";
import store from "@/store/index";

export default {
  components: {
    DataTable,
  },

  data() {
    return {
      erro: false,
      mensagemErro: "Erro",
      item: {},
      subEstoqueSelecionado: null,
      listaSubEstoque: [],
      isLoadingRequestDisable: false,

      headers: [
        {
          text: "ID",
          value: "itemUnidade.numeroItemUnidade",
        },
        {
          text: "Lote",
          value: "item.lote",
        },
        { 
          text: "Nome Produto", 
          value: "nomeItemPadrao" 
        },
        {
          text: "Validade",
          value: "item.validade",
        },
        {
          text: "Quantidade Total em Estoque",
          value: "itemUnidade.quantidadeEstoqueItem",
        }
      ],

      //Form composition
      formComposition: [
        {
          title: "Selecionar Unidade",
          type: "select",
          size: 12,
          modelName: "enderecoordemservico",
        },

        {
          title: "Importar XML",
          type: "file",
          size: 12,
          modelName: "anexoFile",
        },
        {
          modelName: "descricaoTela",
        },
      ],

      //Config para Headers HTTP
      config: {
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": store.state.token,
        },
      },

      //Array populado pela função initialize
      itens: [],
      listaDeMateriais: [],
      //Array Unidade de medida
      unidadesMedida: [],
      teste: [],
    };
  },

  methods: {
    FormataStringData(data) {
      var ano = data.split("-")[0];
      var mes = data.split("-")[1];
      var dia = data.split("-")[2];
      var dia2 = dia.substring(0, 2);
      return ano + "-" + ("0" + mes).slice(-2) + "-" + ("0" + dia2).slice(-2);
    },

    //•••••••••••••••••••••••••••••••••••••//
    //•      FUNÇÕES DE REQUISIÇÃO        •//
    //•••••••••••••••••••••••••••••••••••••//
    async listarMateriais(numeroEndereco, numeroSubEstoque) {
      try {
        const data = { numeroEndereco: numeroEndereco, numeroSubEstoque: numeroSubEstoque };
        const response = await axios.put("itemEstoqueUnidade", data, this.config);

        this.listaDeMateriais = response.data

        const buscarSubEstoque = await axios.put("subestoque", {numeroEndereco: numeroEndereco}, this.config)
        this.listaSubEstoque = buscarSubEstoque.data.map(function(subEstoque){
          return {
            text: subEstoque.nomeSubestoque,
            value: subEstoque.numeroSubestoque
          }
        })

        return response.data;
      } catch (error) {
        console.log(error);
      }
    },

    async updataOpçoes(modalFormName) {
      let novaresposta;

      if (modalFormName == "enderecoordemservico") {
        const responseData = await axios.get(modalFormName, this.config);

        novaresposta = responseData.data.map((row) => {
          return {
            value: row.numeroEnderecoOrdemServico,
            text: row.nomeEndereco,
          };
        });
      }

      return novaresposta;
    },

    async inserir(reciveItem) {
      try {
        this.isLoadingRequestDisable = true;
        reciveItem.descricaoTela = "itens";
        reciveItem.numeroPatrimonio = parseInt(reciveItem.numeroPatrimonio);
        reciveItem.quantidadeAtual = parseInt(reciveItem.quantidadeAtual);
        reciveItem.quantidadeTotal = parseInt(reciveItem.quantidadeTotal);
        if (reciveItem.valorItemIndividual) {
          reciveItem.valorItemIndividual = parseInt(
            reciveItem.valorItemIndividual
          );
        }
        reciveItem.quantidadeAtual = reciveItem.quantidadeTotal;

        await axios.post("item", reciveItem, this.config);

        
        return true;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoadingRequestDisable = false;
      }
    },

    async atualizar(reciveItem) {
      try {
        this.isLoadingRequestDisable = true;
        reciveItem.descricaoTela = "itens";

        await axios.put("item", reciveItem, this.config);
    
        
        return true;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoadingRequestDisable = false;
      }
    },

    async deletar(reciveItem) {
      try {
        this.isLoadingRequestDisable = true;
        reciveItem.descricaoTela = "itens";

        await axios.delete("item", {
          data: reciveItem,
          headers: this.config.headers,
        });
       
        return true;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoadingRequestDisable = false;
      }
    },
  },
};
</script>